//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import trail from './components/trail'
import breadcrumb from './components/breadcrumb'
import grid from './components/grid'
import actions from './components/actions'
import loader from './components/loader'
import smoothReflow from 'vue-smooth-reflow'

export default {
  name: 'DowndraftConfigurator',
  mixins: [smoothReflow],
  components: {
    loader,
    breadcrumb,
    trail,
    grid,
    actions,
  },
  data: function () {
    return {
      observer: null,
      showError: false,
    }
  },
  computed: {
    ...mapGetters(['get']),
    loading() {
      return this.get('loading')
    },
    error() {
      return this.get('error')
    },
    session() {
      return this.$store.state.session
    },
    labels() {
      return this.$store.state.labels
    },
    configurations() {
      return this.$store.state.configurations
    },
    active() {
      return this.configurations.length > 0
        ? this.configurations.filter((config) => config.step === this.session.step)[0]
        : null
    },
  },
  methods: {
    ...mapActions(['fetchData']),
    syncData() {
      this.configurations.forEach((el) => {
        this.$store.commit('setStepOption', { step: el.title, value: null })
      })
    },
    initializeObserver() {
      const doc = getComputedStyle(document.documentElement)
      const breakpoints = [
        ['XL', parseInt(doc.getPropertyValue('--xl'))],
        ['LG', parseInt(doc.getPropertyValue('--lg'))],
        ['MD', parseInt(doc.getPropertyValue('--md'))],
        ['SM', parseInt(doc.getPropertyValue('--sm'))],
        ['XS', parseInt(doc.getPropertyValue('--xs'))],
      ]

      breakpoints.sort((a, b) => (a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0))

      this.observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          breakpoints.some((bp) => {
            let element = entry.target
            let width = entry.contentRect.width
            let current = entry.target.dataset.size

            if (width >= bp[1]) {
              if (current !== bp[0]) {
                element.setAttribute('size', bp[0])
              }
              return true
            }
            return false
          })
        })
      })
    },
  },
  mounted() {
    this.$smoothReflow()
  },
  created() {
    this.initializeObserver()
    let fetchEP = window.location.hostname === 'localhost' ? this.$root.step1 : `${this.$root.api}get/installationoptions`
    this.fetchData(fetchEP)
      .then(() => {
        this.syncData()
      })
      .finally(() => {
        this.$store.commit('write_state', { key: 'loading', value: false })
      })
  },
}
